<main class="public-sav-page" [ngClass]="mode === 'dark' ? 'dark-mode' : 'light-mode'" [ngStyle]="mainStyle">

  <div *ngIf="loading" class="public-sav-loader">
    <div class="loader-ring"></div>
  </div>

  <section *ngIf="!loading" class="public-sav-shell">
    <div class="public-sav-header">
      <div class="public-sav-toolbar">
        <img class="public-sav-logo" [src]="logoPath" [alt]="'publicSavIssue.logoAlt' | translate"
             [class.product-logo]="!!selectedItem?.picture">

        <div class="toolbar-actions">
          <div class="segmented-control">
            <button type="button" [class.active]="currentLanguage === 'fr'" (click)="setLanguage('fr')">FR</button>
            <button type="button" [class.active]="currentLanguage === 'en'" (click)="setLanguage('en')">EN</button>
          </div>

          <button type="button" class="mode-toggle" (click)="toggleMode()">
            <i class="fa" [ngClass]="mode === 'dark' ? 'fa-sun' : 'fa-moon'"></i>
            <span>{{ (mode === 'dark' ? 'publicSavIssue.lightMode' : 'publicSavIssue.darkMode') | translate }}</span>
          </button>
        </div>
      </div>

      <div *ngIf="selectedItem" class="product-name-band">
        <span>{{ selectedItem.name }}</span>
      </div>

      <p class="text-center">{{ 'publicSavIssue.kicker' | translate }}</p>
    </div>

    <form class="public-sav-form" (ngSubmit)="submit()" #issueForm="ngForm">
      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible-custom">
        <span>{{ errorMessage }}</span>
        <button type="button" class="alert-close" (click)="clearErrorMessage()" [attr.aria-label]="'publicSavIssue.close' | translate">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div *ngIf="successTicketNumber" class="alert alert-success alert-dismissible-custom">
        <span>{{ 'publicSavIssue.successMessage' | translate }} <strong>{{ successTicketNumber }}</strong></span>
        <button type="button" class="alert-close" (click)="clearSuccessMessage()" [attr.aria-label]="'publicSavIssue.close' | translate">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div *ngIf="itemUnavailable" class="blocked-state">
        {{ 'publicSavIssue.blockedState' | translate }}
      </div>

      <div class="form-grid" *ngIf="selectedItem">
        <label>
          <span>{{ 'publicSavIssue.customerName' | translate }} *</span>
          <input type="text" name="customerName" [(ngModel)]="form.customerName" required>
        </label>

        <label>
          <span>{{ 'publicSavIssue.phone' | translate }}</span>
          <input type="tel" name="customerPhone" [(ngModel)]="form.customerPhone">
        </label>

        <label>
          <span>{{ 'publicSavIssue.email' | translate }}</span>
          <input type="email" name="customerEmail" [(ngModel)]="form.customerEmail">
        </label>

        <label>
          <span>{{ 'publicSavIssue.priority' | translate }} *</span>
          <ng-select
            [items]="priorities"
            bindLabel="name"
            bindValue="id"
            [placeholder]="'publicSavIssue.priorityPlaceholder' | translate"
            name="priority"
            [(ngModel)]="form.priority"
            required>
          </ng-select>
        </label>
      </div>

      <label *ngIf="selectedItem">
        <span>{{ 'publicSavIssue.issueTitle' | translate }} *</span>
        <input type="text" name="title" [(ngModel)]="form.title" required>
      </label>

      <label class="full-field" *ngIf="selectedItem">
        <span>{{ 'publicSavIssue.description' | translate }} *</span>
        <textarea name="description" rows="6" [(ngModel)]="form.description" required></textarea>
      </label>

      <div class="attachments-section" *ngIf="selectedItem">
        <span class="section-title">{{ 'publicSavIssue.attachments' | translate }}</span>

        <div class="file-grid" *ngIf="selectedFiles.length">
          <div class="file-card" *ngFor="let fileData of selectedFiles; let i = index">
            <div class="file-preview">
              <img *ngIf="isImage(fileData)" [src]="fileData.preview" alt="">
              <i *ngIf="!isImage(fileData)" class="fa-solid fa-2x" [ngClass]="getFileIcon(fileData)"></i>
            </div>

            <div class="file-meta">
              <strong>{{ fileData.file.name }}</strong>
              <small>{{ fileData.file.type || ('publicSavIssue.document' | translate) }}</small>
            </div>

            <div class="file-actions">
              <button type="button" class="icon-button view-button" (click)="openFile(fileData)" [title]="'publicSavIssue.view' | translate">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button type="button" class="icon-button remove-button" (click)="removeFile(i)" [title]="'publicSavIssue.remove' | translate">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <label class="upload-button">
          <input type="file" multiple accept="image/*,.pdf,.doc,.docx" (change)="onFilesSelected($event)">
          <i class="fa fa-cloud-upload-alt"></i>
          {{ 'publicSavIssue.addImages' | translate }}
        </label>
      </div>

      <button *ngIf="selectedItem" type="submit" [disabled]="submitting || !isFormValid()">
        {{ submitting ? ('publicSavIssue.submitting' | translate) : ('publicSavIssue.submit' | translate) }}
      </button>
    </form>
  </section>
</main>
